


export default {
  data: () => ({
    myVariable: 10
  }),
  created() {
  },
  methods: {
    async getTarifarioById(departamento, id) {
      let tarifaCombo = null;
      await this.$store.getters.getFirebaseApp.database.ref("RVA/Tarifas/" + departamento + "/Coleccion/" + id).once("value", (snapshot) => {
        if (snapshot.exists()) {
          tarifaCombo = snapshot.val();
        }
      });
      return tarifaCombo;
    },
    async getSegmentos() {
      let segmentos = [];
      await this.$store.getters.getFirebaseApp.database.ref("RVA/SegmentosReserva").once("value", (snapshot) => {
        if (snapshot.exists()) {
          let arraySegmentos = Object.entries(snapshot.val());
          arraySegmentos.forEach((element) => {
            segmentos.push({ Id: element[0], ...element[1] });
          });
        }
      });
      return segmentos;
    },
    async getMercados() {
      let mercados = [];
      await this.$store.getters.getFirebaseApp.database.ref("RVA/MercadosReserva").once("value", (snapshot) => {
        if (snapshot.exists()) {
          let arrayMercados = Object.entries(snapshot.val());
          arrayMercados.forEach((element) => {
            mercados.push({ Id: element[0], ...element[1] });
          });
        }
      });
      return mercados;
    },
    async getMixTarifasCombo(departamentos) {
      let tarifaCombo = [];
      await this.$store.getters.getFirebaseApp.database.ref("RVA/Tarifas/" + departamentos + "/Coleccion").once("value", (snapshot) => {
        if (snapshot.exists()) {
          let arrayTarifas = Object.entries(snapshot.val());
          arrayTarifas.forEach((element) => {
            tarifaCombo.push({ Id: element[0], ...element[1] });
          });
        }
      });
      return tarifaCombo;
    },
    async getMixTarifasComboByAcceso(departamentos, idMayorista) {
      let tarifaCombo = [];
      await this.$store.getters.getFirebaseApp.database.ref("RVA/Tarifas/" + departamentos + "/Coleccion").orderByChild('Accesos/' + idMayorista).equalTo(true).once("value", (snapshot) => {
        if (snapshot.exists()) {
          let arrayTarifas = Object.entries(snapshot.val());
          arrayTarifas.forEach((element) => {
            tarifaCombo.push({ Id: element[0], ...element[1] });
          });
        }
      });
      return tarifaCombo;
    },
    async getMixTarifasByTarifario(tarifa, departamentos) {
      var data = this.$store.getters.getFirebaseApp.firestore.collection("RVA_Tarifas").where('Tarifario', '==', tarifa)
      data = data.where('Departamento', '==', departamentos);
      data = await data.where("Tenant", "==", this.$store.getters.getFirebaseApp.tenant).get();
      //this.$uvHelper.log(data.docs.map(doc=>{return {id:doc.ref.id,...doc.data()}}));
      let tar = data.docs.map(doc => { return { id: doc.ref.id, ...doc.data() } });
      tar.forEach((tarifaData) => {
        let arrayPrecios = [];
        let arrayDays = Object.entries(tarifaData.Precios);
        arrayDays.forEach((mod) => {
          let modDias = mod[0].split("-");
          let textDias = "";
          modDias.forEach((element) => {
            textDias += " " + this.$uvHelper.getDayName(element, "Simple");
          });
          let arrayModalidades = Object.entries(mod[1]);
          arrayModalidades.forEach((modalidad) => {
            let dataModalidades = { id: modalidad[0], textDias: textDias, dias: modDias, horarios: [] };
            let arrayHorarios = Object.entries(modalidad[1]);
            arrayHorarios.forEach((horario) => {
              let dataHorarios = {
                id: horario[0],
                ...horario[1]
              }
              dataModalidades.horarios.push(dataHorarios);
            });
            arrayPrecios.push(dataModalidades);
          });
          tarifaData.arrayPrecios = arrayPrecios;
        })
      })
      return tar;
    },
    async getMixTarifasByTarifarioParse(tarifa, temporada, departamento, arrayhorarios, arraytemporadas, arraytiposJuego, dayWeek) {
      var data = await this.$store.getters.getFirebaseApp.firestore.collection("RVA_Tarifas").where('Tarifario', '==', tarifa).where('Departamento', '==', departamento);
      if (temporada) {
        data = await data.where('Temporada', '==', temporada);
      }
      data = await data.where("Tenant", "==", this.$store.getters.getFirebaseApp.tenant).get();
      //this.$uvHelper.log(data.docs.map(doc=>{return {id:doc.ref.id,...doc.data()}}));
      let tar = data.docs.map(doc => { return { id: doc.ref.id, ...doc.data() } });
      tar.forEach((tarifaData) => {
        tarifaData.data = this.$uvHelper.getById(arraytemporadas, 'id', tarifaData.Temporada);
        let arrayPrecios = [];
        let arrayDays = Object.entries(tarifaData.Precios);
        arrayDays.forEach((mod) => {
          let modDias = mod[0].split("-");
          let textDias = "";
          modDias.forEach((element) => {
            textDias += " " + this.$uvHelper.getDayName(element, "Simple");
          });
          let arrayModalidades = Object.entries(mod[1]);
          arrayModalidades.forEach((modalidad) => {
            let dataModalidades = { id: modalidad[0], dias: modDias, horarios: [] };
            dataModalidades.data = this.$uvHelper.getById(arraytiposJuego, 'id', modalidad[0]);
            let arrayHorarios = Object.entries(modalidad[1]);
            arrayHorarios.forEach((horario) => {
              let dataHorarios = {
                id: horario[0],
                internalId: tarifaData.id + '-' + dataModalidades.id + '-' + horario[0],
                data: this.$uvHelper.getById(arrayhorarios, 'id', horario[0]),
                ...horario[1]
              }
              dataModalidades.horarios.push(dataHorarios);
            });
            if (dataModalidades.dias.includes(dayWeek.toString())) {
              arrayPrecios.push(dataModalidades);
            }
          });
          tarifaData.arrayPrecios = arrayPrecios;
        })
      })
      return tar;
    },
    async getTarifaById(id) {
      var data = await this.$store.getters.getFirebaseApp.firestore.collection("RVA_Tarifas").doc(id).get();
      let dataTarifa = { id: data.ref.id, ...data.data() };
      return dataTarifa;
    }
  }
};